import { useContext } from "react";
import { SettingContext } from "./App";
import { useDispatch } from "react-redux";
import { setIAAM, setIsAuthenticated, setIsUserApproved, setProfile } from "./redux/iaamSlice";



const iaam_conf = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    iaamgw_host: `https://${process.env.REACT_APP_IAAM_GW_HOST}`,
    op_host: `https://${process.env.REACT_APP_OP_HOST}`,
    post_logout_uri: process.env.REACT_APP_POST_LOGOUT,
    // policyEnforcement: {
    //     aa_host: "https://trbaa.iaam.cloud",
    //     client_name: process.env.REACT_APP_CLIENT_NAME
    // }

}
const iaam = window.iaam;

const IAAMLogin = () => {
    const dispatch = useDispatch();
    iaam.initLoginFlow(iaam_conf)
        .then((init) => {
            iaam.isLoggedIn(async (error, status) => {
                if (!status) {
                    iaam.login()
                }
                else {
                    // const permission = await iaam.policyEnforcement();
                    // console.log(permission)
                    dispatch(setIAAM(iaam));
                    iaam.getProfile(async (err, profile) => {
                        if (!err) {
                            iaam.getAccessToken(async (err, access_token) => {
                                if (!err) {
                                    dispatch(setProfile(profile));
                                    dispatch(setIsUserApproved(profile.userApproved === "true" ? true : false));
                                    dispatch(setIsAuthenticated(true));
                                }
                                else {
                                    iaam.login()
                                }
                            })

                        }
                        else {

                        }
                    })

                }
            })
        })
    return (<></>)
}

export default IAAMLogin